<template>
  <div id="admin_businesses_verification_form">
    <BusinessViewHeader
      :business="business"
      :is_loading="is_loading"
      :is_owner="is_owner"
      :is_on_details_view="false"
      :is_in_admin_view="true"
      :is_in_public_view="false"
    ></BusinessViewHeader>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Missing Information Report"
      id="admin_verify_view_business_missing_info_section"
    ></CardedSectionHeader>
    <div class="white pb-5">
      <CardedTable :items="items" :headers="headers" :show_description="true">
        <template v-slot:description>
          <p class="text-left ml-4 mr-4 red--text" v-if="items.length > 0">
            This business <b>has {{ items.length }} missing</b> information
            items
          </p>
        </template>
      </CardedTable>
    </div>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Verify Business Form"
      id="admin_verify_business_careded_form_section"
    >
      <v-btn
        @click="$router.go(-1)"
        small
        rounded
        class="mr-4"
        outlined
        color="default"
      >
        <v-icon left>mdi-cancel</v-icon> Cancel Verifying
      </v-btn>
    </CardedSectionHeader>
    <CardedForm
      ref="verify_verification_doc_form_ref"
      id="verify_verification_doc_form"
      title="_"
      :is_loading="is_loading"
      @on-submit-form="submit"
      :errors="errors"
      :message="message"
      @on-auto-fill="on_auto_fill"
      @on-close-message="on_hide_message"
      submit_btn_text="Verify"
    >
      <div
        class="d-flex justify-space-between align-center pb-2 pt-2 bb-1-dotted"
        v-for="doc in document_items"
        :key="doc.id"
      >
        <div class="flex-grow-1 text-left pr-2">
          <b>{{ doc.name }}</b>
        </div>
        <div
          :class="
            'pr-5 ' +
            (doc.status == 'not yet provided' ? 'red--text' : 'success--text')
          "
        >
          {{ doc.status }}
        </div>
        <div>
          <v-btn
            small
            rounded
            class="mr-4"
            outlined
            :disabled="is_loading || doc.status == 'not yet provided'"
            :color="doc.status == 'not yet provided' ? 'red' : 'success'"
            :href="doc.url + 'https://www.smartphones.com'"
            target="blank"
          >
            <v-icon left>mdi-eye</v-icon>
            View Doc
          </v-btn>
        </div>
      </div>
      <br />
      <v-alert dense text type="error">
        Please make sure that you have
        <strong>done your due deligence and background checks </strong>
        before verifying this business.
      </v-alert>

      <template v-slot:clearbtnslot>
        <p class="black--text text-left text-h6"></p>
      </template>
    </CardedForm>
  </div>
</template>

<script>
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
import BusinessViewHeader from "../../../components/BusinessViewHeader";
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import CardedTable from "../../../components/CardedTable";
import CardedForm from "../../../components/CardedForm";
export default {
  name: "AdminBusinessesVerify",
  components: {
    BusinessViewHeader,
    CardedSectionHeader,
    CardedTable,
    CardedForm,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {
        return ServerClient.Login.get_logged_in_user();
      },
    },
  },
  data: () => {
    return {
      _user: null,
      business_id: 0,
      business: Utils.get_default_business(),
      is_owner: false,
      items: [],
      headers: [
        {
          text: "Missing",
          align: "start",
          sortable: false,
          value: "missing",
          filterable: true,
        },
        {
          text: "Description",
          align: "start",
          sortable: false,
          value: "description",
          filterable: true,
        },
      ],
      errors: [],
      message: "",
    };
  },
  methods: {
    load_items() {
      this.$emit("on-show-loader");
      ServerClient.Businesses.get_admin_business_missing_info_report(
        {
          id: this.business_id,
        },
        (res) => {
          //console.log("res: ", res);
          var items = Utils.scan_businesses_missing_info(
            res.businesses,
            res.hollidays
          );

          var ids = [];
          var temp_list = [];
          for (var index = 0; index < items.length; index++) {
            var item = items[index];
            if (ids.indexOf(parseInt(item.business_id)) > -1) {
              //already in array, so rmove name
              temp_list.push({
                business_id: parseInt(item.business_id),
                name: "",
                missing: item.missing,
                description: item.description,
              });
            } else {
              //new so dont remove name
              temp_list.push(item);
              ids.push(parseInt(item.business_id));
            }
          }
          this.items = temp_list;
          if (ids.length > 1) {
            alert("There may be a problem with this report");
          }

          this.business = res.businesses[0];

          this.$emit("on-hide-loader");
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading busineeses on missing info list on admin side of things",
            errors
          );
        }
      );
    },
    on_view_item(item) {
      this.$router.push("/admin/businesses/list/view/" + item.id);
    },
    is_uploaded(key) {
      if (this.business && this.business[key]) {
        var link = this.business[key];
        if (link == null) {
          return false;
        }
        link = link.trim();
        if (link.length > 0) {
          return true;
        }
        return false;
      }
      return false;
    },
    on_auto_fill() {
      this.errors = [];
      this.message = "";
    },
    submit() {
      this.errors = [];
      this.message = "";
      var data = {
        verified_by_id: this._user.id,
      };
      ServerClient.Businesses.verify_business(
        {
          data: data,
          id: this.business_id,
        },
        (res) => {
          this.$emit("on-hide-loader");
          this.$refs.verify_verification_doc_form_ref.on_clear_form();
          this.message =
            "<b>Operation was successfull</b> <br/>  File was uploaded successfully";
          this.$refs.verify_verification_doc_form_ref.show_message_dialog();
        },
        (errors) => {
          this.errors = errors;
          this.$refs.verify_verification_doc_form_ref.show_error_dialog();
          this.$emit("on-hide-loader");
        }
      );
    },
    on_hide_message() {},
  },
  computed: {
    document_items() {
      var list = [
        {
          id: "doc_idcopy_url",
          name: "NATIONAL ID or PASSPORT",
          status: this.is_uploaded("doc_idcopy_url")
            ? "uploaded"
            : "not yet provided",
          url: this.business.doc_idcopy_url,
        },
        {
          id: "doc_cert_incoporation_url",
          name: "CERTIFICATE of INCOPORATION",
          status: this.is_uploaded("doc_cert_incoporation_url")
            ? "uploaded"
            : "not yet provided",
          url: this.business.doc_cert_incoporation_url,
        },
        {
          id: "doc_extr_comp_document_url",
          name: "COMPANY EXTRACT",
          status: this.is_uploaded("doc_extr_comp_document_url")
            ? "uploaded"
            : "not yet provided",
          url: this.business.doc_extr_comp_document_url,
        },
        {
          id: "doc_cert_tax_url",
          name: "TAX CERTIFICATE",
          status: this.is_uploaded("doc_cert_tax_url")
            ? "uploaded"
            : "not yet provided",
          url: this.business.doc_cert_tax_url,
        },
        {
          id: "doc_trade_liscence_url",
          name: "TARDE LISCENCE",
          status: this.is_uploaded("doc_trade_liscence_url")
            ? "uploaded"
            : "not yet provided",
          url: this.business.doc_trade_liscence_url,
        },
        {
          id: "doc_registration_cert_url",
          name: "REGISTRATION CERTIFICATE",
          status: this.is_uploaded("doc_registration_cert_url")
            ? "uploaded"
            : "not yet provided",
          url: this.business.doc_registration_cert_url,
        },
      ];
      return list;
    },
  },
  mounted() {
    this.business_id = parseInt(this.$route.params.id);
    this._user = ServerClient.Login.get_logged_in_user();
    //nyd
    //if is not admin please redirect this user to the login screen

    this.$emit("set-page-attributes", {
      title: "Admin Business Verification",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Buinesses",
          disabled: false,
          href: "/admin/businesses",
        },
        {
          text: "List",
          disabled: false,
          href: "/admin/businesses/list",
        },
        {
          text: "View",
          disabled: false,
          href: "/admin/businesses/list/view/" + this.business_id,
        },
        {
          text: "Verify",
          disabled: true,
          href: "/admin/businesses/list/view/" + this.business_id + "/verify",
        },
      ],
      navbar_cols: 3,
    });
    this.load_items();

    var options = {
      offset: 50,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#admin_businesses_verification_form", options);
  },
};
</script>